import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { InvestmentPlanDataService } from '../../services/investment-plan-data.service'
import { FundService } from '../../services/fund.service'
import { Chart } from 'angular-highcharts';

@Component({
  selector: 'app-calculate-step2',
  templateUrl: './calculate-step2.component.html',
  styleUrls: ['./calculate-step2.component.scss']
})
export class CalculateStep2Component implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  @ViewChild('cal2Start') step2: ElementRef
  retirementLength: any
  investmentHorizon: any
  retiremetExpenses: any
  presentValue: any
  futureValue: any
  aom: any
  expectedR: any
  expectedRString: string
  investmentAllocation: Array<Object> = []
  currentSaving: any
  payment: any
  savePercent: any
  userRisk: any
  sd: any
  drawndown: any
  donut: any
  doughnutChartData: any

  haveEq: boolean = false
  eqRatio: any
  haveMM: boolean = false
  mmRatio: any
  haveFi: boolean = false
  fiRatio: any
  haveComm: boolean = false
  commRatio: any
  haveProp: boolean = false
  propRatio: any

  eqGraph: any
  mmGraph: any
  fiGraph: any
  commGraph: any
  propGraph: any

  clickFrom: any
  isRetire: boolean = false
  isGenerald: boolean = false
  generaldInvestment: any

  flag: any

  constructor(private shareData: InvestmentPlanDataService, private fundServeice: FundService) {
    this.doughnutChartData = []
  }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")
    this.clickFrom = sessionStorage.getItem('cilckFrom')
    this.userRisk = parseInt(sessionStorage.getItem('userRisk'))
    this.sd = sessionStorage.getItem('sd')
    this.drawndown = sessionStorage.getItem('drawndown')

    if (this.clickFrom === 'เกษียณ') {
      this.isRetire = true
      this.step2.nativeElement.scrollIntoView({ behavior: "auto", block: "nearest", inline: "nearest" })

      this.retirementLength = sessionStorage.getItem('retirementLength')
      this.investmentHorizon = sessionStorage.getItem('investmentHorizon')
      this.retiremetExpenses = sessionStorage.getItem('payAfterRetire')
      this.presentValue = sessionStorage.getItem('pv')
      this.futureValue = sessionStorage.getItem('fv')
      this.aom = sessionStorage.getItem('aom')
      this.expectedR = sessionStorage.getItem('expectedR')
      this.expectedRString = sessionStorage.getItem('expectedRStr')
      this.investmentAllocation = JSON.parse(sessionStorage.getItem('investmentAllocation'))
      this.currentSaving = sessionStorage.getItem('safeMoney')
      this.payment = sessionStorage.getItem('pmt')
      this.savePercent = sessionStorage.getItem('savePercent')

      this.investmentAllocation.forEach(element => {


        if (element['valuePercent'] !== 0) {
          if (this.flag == 'th') {
            this.eqGraph = [element['fundTypeTH'], element['valuePercent']]
          } else {
            this.eqGraph = [element['fundType'], element['valuePercent']]
          }
          this.doughnutChartData.push(this.eqGraph)

          this.shareData.getInvestmentMapp(element['fundTypeId']).subscribe(response => {
            element['fundMapp'] = response
          })
        }
        
        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: false,
              size: '70%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y.toFixed(2) + ' %';
            }
          },
          series: [{
            type: undefined,
            name: 'Browsers',
            data: this.doughnutChartData,
            innerSize: '35%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y:.2f}% <br/> {point.name}',
              softConnector: false
            }
          }]
        });

      })

    } else if (this.clickFrom === 'เป้าหมาย') {

      this.isGenerald = true
      this.step2.nativeElement.scrollIntoView({ behavior: "auto", block: "nearest", inline: "nearest" })
      this.expectedR = sessionStorage.getItem('expectedR')
      this.generaldInvestment = sessionStorage.getItem('generaldInvestment')
      this.investmentAllocation = JSON.parse(sessionStorage.getItem('investmentAllocation'))

      this.investmentAllocation.forEach(element => {
        if (element['valuePercent'] !== 0) {

          if (this.flag == 'th') {
            this.eqGraph = [element['fundTypeTH'], element['valuePercent']]
          } else {
            this.eqGraph = [element['fundType'], element['valuePercent']]
          }
          this.doughnutChartData.push(this.eqGraph)

          this.shareData.getInvestmentMapp(element['fundTypeId']).subscribe(response => {
            element['fundMapp'] = response


          })
        }

        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: false,
              size: '80%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y.toFixed(2) + ' %';
            }
          },
          series: [{
            type: undefined,
            name: 'Browsers',
            data: this.doughnutChartData,
            innerSize: '35%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y:.2f}% <br/> {point.name}',
              softConnector: false
            }
          }]
        });
      })
    }
  }

  whatClass(val, fundType) {
    let fundRisk = parseInt(val)
    if (this.userRisk < fundRisk) {
      if (fundType == 'Long-Term Equity Fund (LTF)' || fundType == 'Retirement Mutual Fund (RMF)') {
        if ((fundRisk > 5 && fundRisk <= 8) && this.userRisk == 5) {
          return 'tax-fund'
        } else {
          return 'tax-high-risk'
        }
      } else if (fundType != 'Long-Term Equity Fund (LTF)' || fundType != 'Retirement Mutual Fund (RMF)') {
        if ((fundRisk > 5 && fundRisk <= 8) && this.userRisk == 5) {
          return '-bg-white'
        } else {
          return 'nontax-high-risk'
        }
      }
    } else if (this.userRisk >= fundRisk) {
      if (fundType == 'Long-Term Equity Fund (LTF)' || fundType == 'Retirement Mutual Fund (RMF)') {
        if ((fundRisk > 5 && fundRisk <= 8) && this.userRisk == 5) {
          return 'tax-fund'
        } else {
          return 'tax-fund'
        }
      } else if (fundType != 'Long-Term Equity Fund (LTF)' || fundType != 'Retirement Mutual Fund (RMF)') {
        return '-bg-white'
      }
    }

  }
}
